import { Expose } from "@nts/std/serialization";
import { MetaDataRequest } from './meta-data-request';

export class MetaDataExternalRequest extends MetaDataRequest {

    @Expose()
    fullRootModelName: string;
}
